import React from 'react';

export default function AppearanceTab({ appearanceSettings, handleLogoUpload, handleRemoveLogo, handleSaveAppearance, loading, logoPreview, setAppearanceSettings, uploadingLogo }) {
  return (
        <div className="glass-card">
          <h2 className="text-xl sm:text-2xl font-semibold text-white mb-6 sm:mb-8">Aparência do Menu Público</h2>
          <div className="space-y-6 sm:space-y-8">
            
            {/* Logo Upload Section */}
            <div>
              <label className="block text-base font-semibold text-gray-300 mb-4">
                Logomarca do Restaurante
              </label>
              <div className="bg-white/5 border-2 border-white/10 rounded-xl p-6">
                {logoPreview ? (
                  <div className="flex flex-col sm:flex-row items-center gap-6">
                    <div className="relative w-48 h-48 bg-white rounded-full overflow-hidden flex items-center justify-center shadow-lg">
                      <img 
                        src={logoPreview} 
                        alt="Logo Preview" 
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1 space-y-4">
                      <p className="text-gray-300 text-sm">Logo atual do seu restaurante (será exibida em formato circular)</p>
                      <div className="flex flex-col sm:flex-row gap-3">
                        <label className="glass-button-primary cursor-pointer text-center">
                          <input
                            type="file"
                            accept="image/jpeg,image/jpg,image/png,image/webp"
                            onChange={handleLogoUpload}
                            className="hidden"
                            disabled={uploadingLogo}
                          />
                          {uploadingLogo ? 'Enviando...' : 'Alterar Logo'}
                        </label>
                        <button
                          onClick={handleRemoveLogo}
                          className="px-6 py-3 bg-red-500/20 hover:bg-red-500/30 text-red-300 rounded-xl font-medium transition-all duration-200 border border-red-500/30"
                          disabled={loading}
                        >
                          Remover Logo
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <div className="w-24 h-24 mx-auto bg-white/10 rounded-xl flex items-center justify-center mb-4">
                      <svg className="w-12 h-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <p className="text-gray-300 mb-2">Nenhuma logo cadastrada</p>
                    <p className="text-gray-400 text-sm mb-6">Adicione a logo do seu restaurante para aparecer no menu público</p>
                    <label className="glass-button-primary cursor-pointer inline-block">
                      <input
                        type="file"
                        accept="image/jpeg,image/jpg,image/png,image/webp"
                        onChange={handleLogoUpload}
                        className="hidden"
                        disabled={uploadingLogo}
                      />
                      {uploadingLogo ? 'Enviando...' : 'Enviar Logo'}
                    </label>
                    <p className="text-gray-500 text-xs mt-4">JPG, PNG ou WebP - Máximo 5MB</p>
                  </div>
                )}
              </div>
            </div>

            <div>
              <label className="block text-base font-semibold text-gray-300 mb-4">
                Layout do Menu
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <button
                  onClick={() => setAppearanceSettings({ ...appearanceSettings, layout: 'list' })}
                  className={`p-5 sm:p-6 rounded-xl border-2 transition-all duration-200 active:scale-95 ${
                    appearanceSettings.layout === 'list'
                      ? 'border-blue-500 bg-blue-500/20 shadow-lg'
                      : 'border-white/10 bg-white/5 hover:border-white/20 active:bg-white/10'
                  }`}
                  style={{ minHeight: '120px' }}
                  data-testid="appearance-layout-list"
                >
                  <div className="text-left">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="w-10 h-10 bg-white/10 rounded-lg" />
                      <div className="flex-1 space-y-2">
                        <div className="h-3 bg-white/20 rounded-full w-3/4" />
                        <div className="h-2 bg-white/10 rounded-full w-1/2" />
                      </div>
                    </div>
                    <p className="text-white font-semibold text-base mb-1">Layout em Lista</p>
                    <p className="text-gray-400 text-sm">Produtos em lista vertical</p>
                  </div>
                </button>

                <button
                  onClick={() => setAppearanceSettings({ ...appearanceSettings, layout: 'grid' })}
                  className={`p-5 sm:p-6 rounded-xl border-2 transition-all duration-200 active:scale-95 ${
                    appearanceSettings.layout === 'grid'
                      ? 'border-blue-500 bg-blue-500/20 shadow-lg'
                      : 'border-white/10 bg-white/5 hover:border-white/20 active:bg-white/10'
                  }`}
                  style={{ minHeight: '120px' }}
                  data-testid="appearance-layout-grid"
                >
                  <div className="text-left">
                    <div className="grid grid-cols-2 gap-2 mb-4">
                      {[1, 2, 3, 4].map((i) => (
                        <div key={i} className="aspect-square bg-white/10 rounded-lg" />
                      ))}
                    </div>
                    <p className="text-white font-semibold text-base mb-1">Layout em Grade</p>
                    <p className="text-gray-400 text-sm">Produtos em grade</p>
                  </div>
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
              <div>
                <label className="block text-base font-semibold text-gray-300 mb-4">
                  Cor Primária
                </label>
                <div className="space-y-3">
                  <div className="flex items-center space-x-4">
                    <input
                      type="color"
                      className="w-16 h-16 sm:w-14 sm:h-14 rounded-xl cursor-pointer border-2 border-white/10 hover:border-white/20 transition-all"
                      value={appearanceSettings.primary_color}
                      onChange={(e) => setAppearanceSettings({ ...appearanceSettings, primary_color: e.target.value })}
                      data-testid="appearance-primary-color"
                    />
                    <input
                      type="text"
                      className="glass-input flex-1 text-base sm:text-sm"
                      style={{ minHeight: '48px', padding: '12px 16px' }}
                      value={appearanceSettings.primary_color}
                      onChange={(e) => setAppearanceSettings({ ...appearanceSettings, primary_color: e.target.value })}
                      placeholder="#3b82f6"
                    />
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed">Cor do header e botões principais</p>
                </div>
              </div>

              <div>
                <label className="block text-base font-semibold text-gray-300 mb-4">
                  Cor Secundária
                </label>
                <div className="space-y-3">
                  <div className="flex items-center space-x-4">
                    <input
                      type="color"
                      className="w-16 h-16 sm:w-14 sm:h-14 rounded-xl cursor-pointer border-2 border-white/10 hover:border-white/20 transition-all"
                      value={appearanceSettings.secondary_color}
                      onChange={(e) => setAppearanceSettings({ ...appearanceSettings, secondary_color: e.target.value })}
                      data-testid="appearance-secondary-color"
                    />
                    <input
                      type="text"
                      className="glass-input flex-1 text-base sm:text-sm"
                      style={{ minHeight: '48px', padding: '12px 16px' }}
                      value={appearanceSettings.secondary_color}
                      onChange={(e) => setAppearanceSettings({ ...appearanceSettings, secondary_color: e.target.value })}
                      placeholder="#ef4444"
                    />
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed">Cor de destaques e badges</p>
                </div>
              </div>
            </div>

            <div className="flex justify-end pt-4 sm:pt-6 border-t border-white/10">
              <button
                onClick={handleSaveAppearance}
                disabled={loading}
                className="glass-button-primary w-full sm:w-auto"
                style={{ minHeight: '48px', padding: '12px 32px', fontSize: '16px' }}
                data-testid="appearance-save-button"
              >
                {loading ? 'Salvando...' : 'Salvar Aparência'}
              </button>
            </div>
          </div>
        </div>
  );
}
